import React from "react";
import Row from "antd/lib/row";
import { Gutter } from "antd/lib/grid/row";
import Col from "antd/lib/col";
import Card from "antd/lib/card";
import { DEFAULT_ROW_GUTTER, DEFAULT_COLSPAN } from "../../utils/Constants";

interface ICardBlockProps {
  children?: React.ReactNode;
  title?: string;
  rowGutter?: Gutter | [Gutter, Gutter];
  colSpan?: string;
}

const CardBlock: React.FC<ICardBlockProps> = ({
  title,
  children,
  rowGutter,
  colSpan,
}) => (
  <Row gutter={rowGutter || DEFAULT_ROW_GUTTER}>
    <Col span={colSpan || DEFAULT_COLSPAN}>
      <Card title={<strong>{title}</strong>} type="inner">
        {children}
      </Card>
    </Col>
  </Row>
);

export default CardBlock;
